module.exports = __webpack_public_path__ + "public/images/program/program-16.cb23f793c1a21344c19af405a1e67f53.jpg";